<template>
  <dn-link
    v-if="!isLoggedIn"
    id="btn-nhst-login"
    v-track-event="loginTrackingEvent"
    class="dn-login-button default outline"
    :text="t('Login')"
    icon="user"
    href="/login"
    external
    @click="sendLoginLogoutBtnClickedEvent"
  />
  <dn-button
    v-else
    v-track-event="userProfileTrackingEvent"
    :text="showDefaultUserAvatar ? undefined : loggedInUserUserAvatarName"
    :icon="showDefaultUserAvatar ? 'user' : undefined"
    class="pill dn-login-button button-login-status"
    @click="$emit('show-user-menu')"
  />
</template>
<script setup lang="ts">
import { useProfileLoginStore } from '~/store/profileLogin';
const { t } = useI18n();

const showDefaultUserAvatar = useProfileLogin(useProfileLoginStore().loginStatus).showDefaultUserAvatar;
const loggedInUserUserAvatarName = useProfileLogin(useProfileLoginStore().loginStatus).loggedInUserUserAvatarName;
const isLoggedIn = ref(useProfileLoginStore().loginStatus.isLoggedIn);

const loginTrackingEvent = {
  eventName: 'Header',
  component: { zone: 'header', element: 'dn-login', element_id: 'menu-login' },
  attributes: { link_url: 'dn.no/login' }
};

const userProfileTrackingEvent = {
  eventName: 'Header',
  component: { zone: 'header', element: 'dn-login', element_id: 'menu-user-profile' }
};

defineEmits(['show-user-menu']);

const sendLoginLogoutBtnClickedEvent = () => {
  const msgToSend = {
    type: 'nhst-login-click'
  };
  window.postMessage(msgToSend, window.location.origin);
};
</script>

<style lang="scss">
.dn-login-button {
  --dn-login-status-icon_color: var(--color-header-top-fg);
  --dn-header-button_color: var(--color-header-top-fg);
  --dn-header-button_color__hover: var(--color-header-top-fg);

  visibility: visible;

  &.dn-link {
    &.default {
      --dn-header-link_color: var(--dn-header-white-link_color, var(--color-button-secondary-default-fg));
      --color-icon: var(--color-header-top-fg);
      --dn-header-link_color__hover: var(--dn-header-white-link_color__hover, var(--color-button-secondary-default-fg));
      --dn-header-link_color__active: var(--dn-header-white-link_color__active, var(--color-button-secondary-default-fg));

      border-color: var(--color-button-secondary-default-border);

      .dn-icon {
        --color-icon: var(--dn-header-white-link_color, var(--color-button-secondary-default-fg));
      }
    }
  }

  @media only screen and (width < 768px) {
    &.dn-link.default {
      &:not(.button-login-status) {
        flex: 0 0 32px;
        justify-content: center;
        border-color: var(--color-header-top-fg);
        border-radius: 100%;
        padding: 0;

        .dn-icon {
          width: 24px;
          max-width: 24px;
          height: 24px;
          stroke: var(--color-header-top-fg);
          margin-right: 0;

          &:hover,
          &:active {
            stroke: var(--color-header-top-fg);
          }
        }

        .text {
          display: none;
        }
      }
    }
  }
}
</style>
